/*eslint react-hooks/exhaustive-deps: "off"*/
import React, {useCallback, useContext, useState} from "react";
import {Form, Checkbox, Row, Col} from "antd";
import {Title} from "./Common";
import MapPropsContext from "../MapPropsContext";
import Seperator from "./Seperator";


//'SK': [542604, 2390, 48805, 541309, 521297, 195403],
//   'KT': [542610, 2151, 33141, 42233, 83943, 89987],
//   'LG': [39818, 259976]
export const CUSTOMER_OPTIONS = [
  {value: '542604,2390,48805,541309,521297,195403', label: "SKT"},
  {value: '542610,2151,33141,42233,83943,89987', label: "KT"},
  {value: '39818,259976', label: "LGU+"},
];


function WidgetCustomerCode({isAdmin = false}) {
  const {widgetState, onChangeWidgetState} = useContext(MapPropsContext);
  const {cus_code_list} = widgetState;
  const [state, setState] = useState({
    indeterminate: (cus_code_list.length < CUSTOMER_OPTIONS.length),
    checkAll: (cus_code_list.length === CUSTOMER_OPTIONS.length),
  });

  const onCheckAllChange = useCallback(({target: {checked}}) => {
    setState({
      indeterminate: false,
      checkAll: checked,
    });
    onChangeWidgetState({
        target: {
          name: 'cus_code_list',
          value: !checked ? [] : CUSTOMER_OPTIONS.map(({value}) => value),
        }
      }
    );
  }, []);

  const onChange = useCallback((checkedValues) => {
    setState({
      indeterminate: !!checkedValues.length && checkedValues.length < CUSTOMER_OPTIONS.length,
      checkAll: (checkedValues.length === CUSTOMER_OPTIONS.length),
    });

    onChangeWidgetState({
        target: {
          name: 'cus_code_list',
          value: checkedValues,
        }
      }
    );
  }, [onChangeWidgetState, setState]);

  const {indeterminate, checkAll} = state;


  return (
    <Form.Item>

      <Title extra={
        <Checkbox checked={checkAll} indeterminate={indeterminate} onChange={onCheckAllChange}>
          전체 선택
        </Checkbox>
      }>
        사업자
      </Title>
      <Checkbox.Group name="cus_code_list"
                      value={cus_code_list}
                      onChange={onChange}
                      size={"small"}
                      style={{width: '100%'}}>
        <Row>
          {CUSTOMER_OPTIONS.map(({value, label}) =>
            <Col span={8} key={value}>
              <Checkbox value={value} key={label}>
                {label}
              </Checkbox>
            </Col>
          )}
        </Row>
      </Checkbox.Group>

      <Seperator/>
    </Form.Item>
  );
}


export default WidgetCustomerCode;
